"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _pageMetadata = _interopRequireDefault(require("./page-metadata"));

var _sections = _interopRequireDefault(require("./sections"));

var _reactUtils = require("../react-utils");

var _page = require("../../models/page");

var _pageMetadata2 = require("../../models/page-metadata");

var _util = require("./util");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * Renders components based off of Contentful Page Model :
 * example: https://app.contentful.com/spaces/ljtyf78xujn2/entries/3ryy5hMRpuCkWEGUIEkQ68
 */
var Page = function Page(props) {
  var pageType = props.pageType,
      title = props.title,
      pageTitleText = props.pageTitleText,
      metaDescription = props.metaDescription,
      stringSubstitutions = props.stringSubstitutions,
      pageMetadata = props.pageMetadata,
      className = props.className;
  var helmet = (0, _reactUtils.includeWhen)(pageType === 'standalone', function () {
    return /*#__PURE__*/_react["default"].createElement(_pageMetadata["default"], _extends({}, (0, _pageMetadata2.interpretMetadata)(pageMetadata, stringSubstitutions), {
      pageTitleText: pageTitleText || title,
      metaDescription: (0, _util.stringSubstitution)(metaDescription, stringSubstitutions)
    }));
  });
  var header = (0, _reactUtils.includeWhen)(title, function () {
    return /*#__PURE__*/_react["default"].createElement("h1", {
      className: "h1"
    }, (0, _util.stringSubstitution)(title, stringSubstitutions));
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "Page contentPage ".concat(className)
  }, helmet, header, /*#__PURE__*/_react["default"].createElement(_sections["default"], _extends({}, props, {
    className: "content"
  })));
};

Page.propTypes = _objectSpread(_objectSpread({}, _page.pagePropType), {}, {
  className: _propTypes["default"].string
});
Page.defaultProps = {
  className: ''
};
var _default = Page;
exports["default"] = _default;